// src/components/VerifyEmail/VerifyPhonePrompt.jsx
// Verificación de teléfono por OTP (KYC Fase 1). Dos pasos: ingresar teléfono →
// recibir SMS → ingresar código. Requiere proveedor SMS (Twilio); por eso el caller
// lo gatea con REACT_APP_SMS_ENABLED (no se muestra hasta conectar el proveedor).
// Se auto-oculta si el teléfono ya está verificado.
import React, { useState } from 'react';
import { FiPhone, FiCheckCircle, FiArrowRight } from 'react-icons/fi';
import { useAuth } from '../../Context/AuthContext';
import './VerifyEmailPrompt.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export default function VerifyPhonePrompt() {
  const { user, updateUser } = useAuth();
  const [phase, setPhase]   = useState('phone'); // phone | code
  const [phone, setPhone]   = useState(user?.phone || '');
  const [code, setCode]     = useState('');
  const [loading, setLoad]  = useState(false);
  const [error, setError]   = useState('');
  const [info, setInfo]     = useState('');

  if (user?.phoneVerified) return null;

  const authHeaders = { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` };

  const sendOtp = async (e) => {
    e.preventDefault();
    setError(''); setInfo('');
    if (phone.replace(/\D/g, '').length < 8) { setError('Ingresá tu teléfono con código de país (ej. +506…).'); return; }
    setLoad(true);
    try {
      const res  = await fetch(`${API_URL}/api/send-phone-otp`, { method: 'POST', headers: authHeaders, body: JSON.stringify({ phone: phone.trim() }) });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message || 'No se pudo enviar el código.');
      setInfo(data.message || 'Te enviamos un código por SMS.');
      setPhase('code');
    } catch (err) {
      setError(err.message === 'Failed to fetch' ? 'No se pudo conectar al servidor.' : err.message);
    } finally { setLoad(false); }
  };

  const verify = async (e) => {
    e.preventDefault();
    setError(''); setInfo('');
    if (!/^\d{6}$/.test(code.trim())) { setError('El código son 6 dígitos.'); return; }
    setLoad(true);
    try {
      const res  = await fetch(`${API_URL}/api/verify-phone`, { method: 'POST', headers: authHeaders, body: JSON.stringify({ code: code.trim() }) });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message || 'Código inválido o vencido.');
      updateUser({ phone: phone.trim(), phoneVerified: true });
    } catch (err) {
      setError(err.message);
    } finally { setLoad(false); }
  };

  return (
    <div className="ve">
      <div className="ve-head">
        <span className="ve-ic"><FiPhone /></span>
        <div>
          <h3 className="ve-title">Verificá tu teléfono</h3>
          <p className="ve-sub">Sumá una capa de seguridad a tu cuenta con un código por SMS (verificación por niveles).</p>
        </div>
      </div>

      {phase === 'phone' ? (
        <form className="ve-form" onSubmit={sendOtp}>
          <input
            className="ve-input" type="tel" placeholder="+506 8888 8888"
            style={{ letterSpacing: 'normal', textAlign: 'left', fontSize: '0.95rem' }}
            value={phone} onChange={e => setPhone(e.target.value)} autoComplete="tel"
          />
          <button type="submit" className="ve-btn" disabled={loading}>
            {loading ? <span className="ve-spin" /> : <>Enviar código <FiArrowRight /></>}
          </button>
        </form>
      ) : (
        <form className="ve-form" onSubmit={verify}>
          <input
            className="ve-input" placeholder="000000" inputMode="numeric"
            value={code} onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))} maxLength={6}
          />
          <button type="submit" className="ve-btn" disabled={loading}>
            {loading ? <span className="ve-spin" /> : <><FiCheckCircle /> Verificar</>}
          </button>
        </form>
      )}

      {error && <div className="ve-msg err">{error}</div>}
      {info  && <div className="ve-msg ok">{info}</div>}
      {phase === 'code' && (
        <button type="button" className="ve-resend" onClick={() => { setPhase('phone'); setInfo(''); setError(''); }}>
          Cambiar el número
        </button>
      )}
    </div>
  );
}
